export const siteInfo = {
  name: '古古漫画网',
  slogan: '追更连载 · 每日更新 · 免费全集',
  tagline: '国漫日漫韩漫，人气漫画一网打尽',
  description:
    '古古漫画网是专业的在线漫画阅读平台，汇集海量国漫、日漫、韩漫热门作品。我们坚持每日更新追更连载，提供免费全集下拉式阅读体验，让每一位漫迷都能畅享人气漫画的精彩世界。无论你是热血少年、恋爱甜宠还是悬疑推理的爱好者，古古漫画网都能满足你的阅读需求。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '收录作品', value: '50,000+' },
    { label: '活跃漫迷', value: '800万+' },
  ],
};

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '每日更新不等待',
    desc: '国漫日漫韩漫追更连载实时同步，每日新鲜内容准时上线，热门漫画第一时间送达，追更党不再焦急等待。',
  },
  {
    icon: 'ri-book-open-line',
    title: '免费全集随心看',
    desc: '所有漫画作品免费阅读，海量全集任你畅读。无需付费订阅，零门槛享受人气漫画的沉浸式阅读乐趣。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '独创下拉式阅读模式，一滑到底连续翻页，告别频繁点击。沉浸式漫画体验，阅读节奏行云流水般顺畅。',
  },
  {
    icon: 'ri-global-line',
    title: '海量漫画全覆盖',
    desc: '涵盖热血、恋爱、悬疑、玄幻、搞笑等全品类题材，国漫精品与日漫韩漫热门一应俱全，满足各类漫迷口味。',
  },
];

export const updates = [
  { time: '10分钟前', title: '《斗破苍穹》第428话更新', tag: '国漫', type: 'hot' },
  { time: '28分钟前', title: '《海贼王》第1122话更新', tag: '日漫', type: 'new' },
  { time: '1小时前', title: '《我独自升级》第203话更新', tag: '韩漫', type: 'hot' },
  { time: '2小时前', title: '《完美世界》第315话更新', tag: '国漫', type: '' },
  { time: '3小时前', title: '《咒术回战》第272话更新', tag: '日漫', type: 'new' },
  { time: '4小时前', title: '《全职高手》第197话更新', tag: '国漫', type: '' },
  { time: '5小时前', title: '《间谍过家家》第108话更新', tag: '日漫', type: '' },
];

export const aboutInfo = {
  title: '关于古古漫画网',
  paragraphs: [
    '古古漫画网成立于2018年，是国内领先的免费在线漫画阅读平台之一。我们深耕漫画领域多年，始终坚持为漫迷提供优质的阅读体验和丰富的漫画内容资源。',
    '平台现已收录超过五万部国漫、日漫、韩漫作品，涵盖热血少年、恋爱甜宠、悬疑推理、玄幻修仙、搞笑日常等全品类题材。从经典长篇连载到当下最火爆的新番，古古漫画网一网打尽，满足每一位漫迷的阅读需求。',
    '我们的使命是让每一位热爱漫画的读者都能随时随地享受追更连载的乐趣。每日200+章节更新量，确保你永远不会错过任何一部人气漫画的最新动态。下拉式阅读模式的流畅体验和免费全集的零门槛访问，让漫画阅读回归纯粹的快乐。',
  ],
};

export const rankings = [
  { rank: 1, title: '斗破苍穹', author: '天蚕土豆 / 任翔', tag: '国漫', heat: '9.8', category: '玄幻热血' },
  { rank: 2, title: '海贼王', author: '尾田荣一郎', tag: '日漫', heat: '9.7', category: '冒险热血' },
  { rank: 3, title: '我独自升级', author: 'Chugong / DUBU', tag: '韩漫', heat: '9.6', category: '奇幻战斗' },
  { rank: 4, title: '完美世界', author: '辰东', tag: '国漫', heat: '9.5', category: '玄幻修仙' },
  { rank: 5, title: '咒术回战', author: '芥见下下', tag: '日漫', heat: '9.4', category: '暗黑战斗' },
  { rank: 6, title: '一人之下', author: '米二', tag: '国漫', heat: '9.3', category: '异能都市' },
  { rank: 7, title: '间谍过家家', author: '远藤达哉', tag: '日漫', heat: '9.2', category: '搞笑温情' },
];

export const cards = [
  {
    title: '玄幻修仙专题',
    desc: '斗破苍穹、完美世界、凡人修仙传等顶级国漫持续连载，每日更新不缺席，修仙世界的热血冒险永不落幕。',
    tag: '国漫热门',
  },
  {
    title: '热血冒险专题',
    desc: '海贼王、火影忍者、鬼灭之刃等日漫经典IP，陪伴一代人成长的冒险旅程，全集免费畅读。',
    tag: '日漫经典',
  },
  {
    title: '韩漫精选专题',
    desc: '我独自升级、全知读者视角、剑尊归来等韩漫爆款，独特画风与紧凑剧情引爆追更热潮。',
    tag: '韩漫爆款',
  },
  {
    title: '恋爱甜宠专题',
    desc: '从校园纯爱到都市浪漫，精选高甜漫画陪伴你的悠闲时光，心跳加速的甜蜜故事尽在掌握。',
    tag: '甜宠推荐',
  },
  {
    title: '悬疑推理专题',
    desc: '烧脑剧情层层反转，悬疑漫画带你体验智力对决的刺激。每一话都让你迫不及待想看下一章。',
    tag: '烧脑必追',
  },
  {
    title: '搞笑日常专题',
    desc: '轻松治愈的搞笑漫画，承包你的每日笑点。工作学习之余，来这里尽情释放压力开怀一笑。',
    tag: '轻松解压',
  },
];

export const indexItems = [
  { letter: 'D', title: '斗破苍穹', tag: '国漫' },
  { letter: 'H', title: '海贼王', tag: '日漫' },
  { letter: 'W', title: '我独自升级', tag: '韩漫' },
  { letter: 'W', title: '完美世界', tag: '国漫' },
  { letter: 'Z', title: '咒术回战', tag: '日漫' },
  { letter: 'Y', title: '一人之下', tag: '国漫' },
  { letter: 'J', title: '间谍过家家', tag: '日漫' },
  { letter: 'Q', title: '全职高手', tag: '国漫' },
];

export const topics = [
  { name: '国漫崛起', count: '128万讨论' },
  { name: '日漫新番', count: '96万讨论' },
  { name: '韩漫推荐', count: '73万讨论' },
  { name: '漫画排行', count: '65万讨论' },
  { name: '追更打卡', count: '58万讨论' },
  { name: '漫画壁纸', count: '47万讨论' },
  { name: '同人创作', count: '39万讨论' },
  { name: '漫评吐槽', count: '34万讨论' },
  { name: '动画化期待', count: '28万讨论' },
];

export const appInfo = {
  title: '随时随地，畅享漫画',
  desc: '古古漫画网移动端适配完美，无需下载APP，浏览器打开即可享受流畅的下拉式阅读体验。手机、平板、电脑多端同步阅读记录，追更连载实时推送，不错过任何一话更新。',
  features: ['下拉式流畅阅读', '多端进度同步', '每日更新提醒', '离线缓存阅读'],
};

export const mediaItems = [
  {
    title: '《斗破苍穹》动画PV首发',
    desc: '萧炎决战云岚宗名场面震撼还原，国漫制作水准再攀高峰！',
    tag: '动画',
    duration: '03:25',
  },
  {
    title: '2026夏季新番导览特辑',
    desc: '本季最值得追的日漫新番全盘点，从热血到治愈一网打尽。',
    tag: '导览',
    duration: '08:12',
  },
  {
    title: '漫迷专访：国漫声优面对面',
    desc: '人气声优独家分享配音幕后故事，带你走进漫画之外的精彩世界。',
    tag: '专访',
    duration: '12:40',
  },
];

export const faqs = [
  {
    q: '古古漫画网所有漫画都是免费的吗？',
    a: '是的，古古漫画网上所有漫画作品均为免费阅读。我们坚持免费全集策略，无需任何付费订阅即可畅读全部内容，让每一位漫迷都能零门槛享受漫画的乐趣。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '古古漫画网每日更新超200话内容，追更连载实时同步作者更新进度。热门漫画如斗破苍穹、海贼王等热门IP基本保持与官方同步的更新节奏，国漫一般每周更新1-2话，日漫和韩漫则根据作者连载进度每日或每周更新。',
  },
  {
    q: '下拉式阅读模式如何使用？',
    a: '进入任意漫画阅读页后，直接向下滑动即可连续阅读，无需点击翻页按钮。阅读到章节末尾时会自动加载下一话内容，实现无缝衔接的沉浸式阅读体验。同时支持键盘方向键快捷操作，方便电脑端用户。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '古古漫画网全面适配手机、平板和电脑端，无需下载APP，浏览器直接打开即可阅读。所有设备自动适配最佳显示效果，阅读进度多端云端同步，随时随地拿起设备接着看。',
  },
];

export const contactInfo = {
  title: '联系我们',
  desc: '如果你有任何关于漫画内容的建议、版权问题反馈、合作意向或投稿需求，欢迎通过以下方式与我们取得联系。我们重视每一位漫迷和创作者的声音，期待与你共同打造更好的漫画阅读社区。',
  email: 'contact@gugumanga.com',
  wechat: '古古漫画网',
  qq: '1234567890',
};

export const carouselItems = [
  {
    title: '国漫崛起：从斗破苍穹看中国动漫产业新高度',
    desc: '近年来国漫制作水准突飞猛进，以斗破苍穹为代表的玄幻修仙题材凭借精良画风和紧凑剧情，不仅在国内收获超高人气，更在海外引发追更热潮。古古漫画网为你深度解析国漫崛起的背后故事。',
    tag: '深度专题',
  },
  {
    title: '日漫经典IP盘点：那些陪伴青春的连载回忆',
    desc: '从海贼王到咒术回战，从火影忍者到鬼灭之刃，日漫陪伴了一代又一代人的成长。古古漫画网为你整理那些不可错过的日漫经典，全集免费阅读，重温热血与感动。',
    tag: '经典回顾',
  },
  {
    title: '韩漫热潮来袭：我独自升级领衔韩漫新势力',
    desc: '韩漫以其独特的全彩条漫形式和紧凑的剧情节奏，近年来在全球范围内掀起阅读热潮。古古漫画网精选人气韩漫，带你感受韩国漫画的独特魅力与视觉冲击力。',
    tag: '趋势解读',
  },
  {
    title: '追更党福利：古古漫画网每日更新最全指南',
    desc: '掌握每日更新时间表，第一时间追更你最喜欢的连载漫画。古古漫画网整理了各大人气作品的更新规律与最佳阅读节奏，让你成为最懂追更的硬核漫迷。',
    tag: '追更攻略',
  },
];

export const comments = [
  {
    avatar: '漫迷小陈',
    text: '古古漫画网真的太好用了！下拉式阅读体验超级流畅，再也不用频繁点击翻页了。每天都会来看看斗破苍穹有没有更新，国漫现在质量真的越来越高了。',
    time: '2天前',
  },
  {
    avatar: '二次元阿宇',
    text: '朋友推荐的这个漫画网站，用了三个月了，日漫韩漫资源很全，海贼王和咒术回战都是在这里追的，更新速度基本和日方同步，关键是完全免费！',
    time: '3天前',
  },
  {
    avatar: '追更达人小敏',
    text: '作为重度的漫画爱好者，古古漫画网是我每天必打开的网站。热门漫画每日更新的速度太给力了，而且全免费，强烈推荐给所有喜欢看漫画的朋友。',
    time: '5天前',
  },
  {
    avatar: '热血漫饭老王',
    text: '从贴吧时代就开始追漫画了，古古漫画网是我用过最舒服的平台。国漫日漫韩漫在一个站就能看完，不用来回切换，手机上看体验也很棒。',
    time: '1周前',
  },
  {
    avatar: '漫画收藏家小小',
    text: '下拉式阅读模式真的是漫画党的福音！看一整天都不累，而且作品库超全，很多小众的韩漫也能找到。已经安利给身边所有同事了。',
    time: '1周前',
  },
];

export const footerNavGroups = [
  {
    title: '热门漫画',
    links: ['斗破苍穹', '海贼王', '我独自升级', '完美世界', '咒术回战', '一人之下'],
  },
  {
    title: '漫画分类',
    links: ['国漫专区', '日漫专区', '韩漫专区', '热血冒险', '玄幻修仙', '恋爱甜宠'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '更新公告', '版权声明', '隐私政策'],
  },
  {
    title: '帮助支持',
    links: ['阅读指南', '常见问题', '意见反馈', '商务合作'],
  },
];